/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/contract.ts":
/*!*************************!*\
  !*** ./src/contract.ts ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EventNames": () => (/* binding */ EventNames),
/* harmony export */   "FunctionNames": () => (/* binding */ FunctionNames)
/* harmony export */ });
/*
 * Copyright by Intland Software
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Intland Software. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with Intland.
 */
// Exchanges
var FunctionNames;
(function (FunctionNames) {
    FunctionNames["AUTHENTICATE"] = "authenticate";
    FunctionNames["RESIZE"] = "resize";
    FunctionNames["GET_SELECTED_ITEM"] = "getSelectedItem";
    FunctionNames["GET_SELECTED_STREAM"] = "getSelectedStream";
    FunctionNames["GET_SELECTED_STREAM_BASELINE"] = "getSelectedStreamBaseline";
    FunctionNames["RELOAD_ITEM"] = "reloadItem";
    FunctionNames["GET_CONFIG"] = "getConfig";
    FunctionNames["GET_BASEURL"] = "getBaseURL";
    FunctionNames["GET_PREFERRED_LANGUAGE"] = "getPreferredLanguage";
})(FunctionNames || (FunctionNames = {}));
// Events
var EventNames;
(function (EventNames) {
    EventNames["SELECTED_ITEM_CHANGED"] = "selectedItemChanged";
    EventNames["SELECTED_STREAM_CHANGED"] = "selectedStreamChanged";
    EventNames["SELECTED_STREAM_BASELINE_CHANGED"] = "selectedStreamBaselineChanged";
    EventNames["PREFERRED_LANGUAGE_CHANGED"] = "preferredLanguageChanged";
})(EventNames || (EventNames = {}));


/***/ }),

/***/ "./src/types-utils.ts":
/*!****************************!*\
  !*** ./src/types-utils.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/*
 * Copyright by Intland Software
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Intland Software. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with Intland.
 */



/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/*
 * Copyright by Intland Software
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Intland Software. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with Intland.
 */



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EventNames": () => (/* reexport safe */ _contract__WEBPACK_IMPORTED_MODULE_2__.EventNames),
/* harmony export */   "FunctionNames": () => (/* reexport safe */ _contract__WEBPACK_IMPORTED_MODULE_2__.FunctionNames)
/* harmony export */ });
/* harmony import */ var _types_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types-utils */ "./src/types-utils.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _contract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./contract */ "./src/contract.ts");
/*
 * Copyright by Intland Software
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Intland Software. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with Intland.
 */




})();

exports.EventNames = __webpack_exports__.EventNames;
exports.FunctionNames = __webpack_exports__.FunctionNames;
Object.defineProperty(exports, "__esModule", { value: true });
/******/ })()
;
//# sourceMappingURL=index.js.map